import { Routes, Route } from "react-router";
import Layout from './components/Layout';
import { JobsView } from "./components/JobsView";
import { JobView } from "./components/JobView";
import { FormView } from "./components/form/FormView";
import Sitemap from "./components/Sitemap";
import { SettingsProvider } from "./SettingsProvider";
import DefaultRedirection from "./components/Default";
import { Helmet } from "react-helmet";

const App = () => {
  return (
    <Layout>
      <Helmet>
        <meta 
          name="description"
          content="Übersichtsseite der veröffentlichten Stellenausschreibungen"
        />
      </Helmet>
      <Routes>
        <Route path="/" element={<DefaultRedirection/>}/>
        <Route path="/:tenant/:listName" element={<SettingsProvider><JobsView /></SettingsProvider>} />
        <Route path="/:tenant/:listName/:id" element={<SettingsProvider><JobView /></SettingsProvider>} />
        <Route path="/:tenant/:listName/:id/form" element={<SettingsProvider><FormView /></SettingsProvider>} />
        <Route path='/:tenant/sitemap.xml' element={<Sitemap />} />
      </Routes>
    </Layout>
  );
}

export default App;
